module.exports = __webpack_public_path__ + "img/gnzs10.0a6cba34.png";